import { ChangePasswordView } from '@/views/anonymous/auth';

export default [
  {
    path: '/change-password',
    name: 'app_auth_change_password',
    meta: { title: 'Change Password', redirectAuthenticatedUsers: false, requiresAuthentication: true },
    component: ChangePasswordView,
  },
];
